export const header = theme => ({
    '&:before': {
        backgroundImage: 'none',
    },
})
